export default {
     API_BASE: "https://order.zore.com.tr",
}
//https://order.zore.com.tr
//https://localhost:44372
